<form [formGroup]="form" (ngSubmit)="onSubmit()" class="cash-receipts py-4 px-1 px-sm-5 position-relative">
    <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" (click)="close()"></i>
    <h4 class="text-center text-strong">Cargar recibos de caja</h4>

    <div class="alert alert-info" role="alert">
        <p class="mb-0">Adjunta el archivo de Excel con los recibos de caja. El resumen del procesamiento te llegará por
            correo.</p>
    </div>

    <div class="cash-receipts__upload mt-3 cursor-pointer" (click)="openFileInput()">
        <input type="file" id="cashReceiptsInput" class="d-none" (change)="onFileSelected($event)"
            accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
        <div class="d-flex flex-row align-items-center">
            <img class="mr-3"
                [src]="form?.get('file')?.value?.name ? 'assets/svg/icons/icon-correct.svg' : 'assets/svg/icons/icon-upload.svg'"
                alt="">
            <div>
                <p class="m-0 text-bold">{{form?.get('file')?.value?.name}}</p>
                <p class="m-0"><u>Subir archivo de Excel</u></p>
                <p class="m-0 cash-receipts__hint">Debe tener extensión .xlsx</p>
            </div>
        </div>
    </div>

    <div class="w-100 mt-4 button-container">
        <button type="button" mat-raised-button class="primary-secondary" color="primary" (click)="close()"
            [disabled]="isLoading">
            Cancelar
        </button>
        <button mat-raised-button class="bg-color-primary" color="primary" type="submit" [disabled]="isLoading">
            Enviar
        </button>
    </div>
</form>
